import { gql } from "@apollo/client";

export const CREATE_USER_ADDRESS = gql`
  mutation AddUserAddress($data: userAddressDataInput!) {
    addUserAddress(data: $data) {
      id
    }
  }
`;

export const DELETE_USER_CONFIRM = gql`
  mutation DelUserAddress($where: UserAddressWhereInput!) {
    delUserAddress(where: $where) {
      message
    }
  }
`;

export const UPDATE_USER_ADDRESS = gql`
  mutation PutUserAddress($where: UserAddressWhereInput!, $data: userAddressDataInput!) {
    putUserAddress(where: $where, data: $data) {
      message
    }
  }
`;
